import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../i18n/LanguageContext";

/**
 * Returns the user-facing display label for a heroContent key.
 * Strips sub-section suffixes (e.g. "Settings:ChangePassword" → "Settings").
 */
const DISPLAY_LABEL_OVERRIDES = {
  "Member User Info": "User Management",
};

function getDisplayLabel(contentKey) {
  if (!contentKey) return "";
  const base = contentKey.split(":")[0];
  return DISPLAY_LABEL_OVERRIDES[base] ?? base;
}

/**
 * BackButton — renders a "← Back to [Page]" link above page content.
 * Renders nothing when there is no previous page to go back to.
 *
 * @param {string|null} previousContent - The heroContent key of the previous page.
 * @param {Function} goBack - Callback to navigate back to the previous page.
 */
function BackButton({ previousContent, goBack }) {
  const { t } = useTranslation();

  if (!previousContent) return null;

  const label = getDisplayLabel(previousContent);

  return (
    <button
      className="btn btn-ghost btn-sm btn-back"
      onClick={goBack}
      aria-label={`${t("common.backTo")} ${label}`}
      type="button"
    >
      <FontAwesomeIcon icon={faArrowLeft} />
      {t("common.backTo")} {label}
    </button>
  );
}

export default BackButton;
